import React, { useState } from "react";
import {
  Container,
  Typography,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  Card,
  Menu,
  MenuItem,
  ListItemIcon,
  Chip,
  Box,
  useMediaQuery,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import {
  Delete,
  MoreVert,
  Create,
  FileCopy,
  ArrowBack,
} from "@material-ui/icons";
import { MANAGER_ROUTES } from "../../utils/constants";
import { useBmapi } from "../../utils/bmapi-context";
import { useIntl } from "react-intl";
import { useHistory, Link as RouterLink } from "react-router-dom";
import { getErrorMessageString } from "../../utils/errors";
import { campaign, common, confirm, form } from "../../messages";
import Confirm from "../../ui/Confirm";
import styles from "../../utils/styles";
import { parseBmarkenDate } from "../../utils/utils";
import { format } from "date-fns";
import TableChecks from "../../ui/TableChecks";
import ImagePreview from "../../components/ImagePreview";

function byDate(a, b) {
  return new Date(a.message.expire_at) < new Date(b.message.expire_at);
}

export default function MessagesCampaignList({
  campaignId,
  campaigns,
  messages,
}) {
  const history = useHistory();
  const classes = styles.useStyles();
  const [showDeleteAlert, setShowDeleteAlert] = React.useState(false);
  const [message, setMessage] = React.useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const intl = useIntl();
  const messagesCampaigns = campaignId
    ? messages.filter((x) => x.message.campaign_id == campaignId)
    : messages;
  const {
    bmapi,
    startLoading,
    stopLoading,
    notifySuccess,
    notifyError,
  } = useBmapi();

  const [imgDialog, setImgDialog] = useState({
    open: false,
    title: "",
    url: "",
  });

  const openImg = (title, url) => {
    if (!url) return;
    setImgDialog({ open: true, title, url });
  };

  const closeImg = () => setImgDialog({ open: false, title: "", url: "" });

  const smallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const getExpDate = (date) => {
    const chechedDate = parseBmarkenDate(date);
    return !chechedDate
      ? "-"
      : format(new Date(parseBmarkenDate(date)), "dd/MM/yyyy");
  };

  const handleOpen = (e, id) => {
    const target = e.currentTarget;
    setAnchorEl(target);
    setMessage(id);
  };

  const handleEdit = () => {
    history.push(
      MANAGER_ROUTES.EDIT_MESSAGE_CAMPAIGN.replace(":messageId?/", message)
    );
  };

  const handleDuplicate = () => {
    history.push(
      (MANAGER_ROUTES.EDIT_MESSAGE_CAMPAIGN + "/clone").replace(
        ":messageId?/",
        message
      )
    );
  };

  const handleConfirm = () => {
    startLoading();
    return bmapi
      .removeMessageCampaign(message)
      .then(() => {
        notifySuccess(
          intl.formatMessage({
            id: "pages.messageCampaign.removed",
            defaultMessage: "Messaggio cancellato con successo",
          })
        );
        location.reload();
        history.push(
          MANAGER_ROUTES.MESSAGES_CAMPAIGNS.replace(":campaignId?/", "")
        );
      })
      .catch((e) => {
        notifyError(getErrorMessageString(e, intl));
        stopLoading();
      });
  };

  const Thumb = ({ url, title }) => {
    if (!url) return <Box width={36} height={36} />;

    return (
      <Box
        onClick={() => openImg(title, url)}
        style={{
          width: 36,
          height: 36,
          borderRadius: 4,
          overflow: "hidden",
          cursor: "pointer",
          border: "1px solid rgba(0,0,0,0.12)",
          display: "inline-flex",
        }}
        title="Apri preview"
      >
        <img
          src={url}
          alt={title}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
          }}
        />
      </Box>
    );
  };

  return (
    <Container maxWidth="xl">
      <Box mt={2} mb={2}>
        <Button
          component={RouterLink}
          to={MANAGER_ROUTES.HOME}
          startIcon={<ArrowBack />}
        >
          {intl.formatMessage(common.backHome)}
        </Button>
      </Box>
      <Card>
        {smallScreen &&
          messagesCampaigns.sort(byDate).map((option, i) => (
            <React.Fragment key={option.message.id}>
              {i !== 0 && <Divider />}
              <List>
                <ListItem>
                  <ListItemText
                    style={{ marginRight: "10%" }}
                    primary={
                      <Box>
                        <Typography>{option.message.title}</Typography>
                        <div style={{ display: "flex", marginTop: "3px" }}>
                          {option.mobile_config.banner && (
                            <Typography gutterBottom>
                              <Chip
                                component="span"
                                label={intl.formatMessage(form.banner)}
                                size="small"
                                className={classes.listChip}
                              />
                            </Typography>
                          )}
                          {option.mobile_config.push_notification && (
                            <Typography gutterBottom>
                              <Chip
                                component="span"
                                label={intl.formatMessage(form.push)}
                                size="small"
                                className={classes.listChip}
                              />
                            </Typography>
                          )}
                        </div>
                      </Box>
                    }
                    secondary={
                      <React.Fragment>
                        <Typography>
                          {campaigns.find(
                            (x) => x.campaign_id == option.message.campaign_id
                          )
                            ? campaigns.find(
                                (x) =>
                                  x.campaign_id == option.message.campaign_id
                              ).name
                            : intl.formatMessage(campaign.noCampaign)}
                        </Typography>
                        <Typography>
                          {`${intl.formatMessage(
                            common.expirationDate
                          )}: ${getExpDate(option.message.expire_at)}`}
                        </Typography>
                      </React.Fragment>
                    }
                    secondaryTypographyProps={{ component: "span" }}
                  />
                </ListItem>
                <ListItemSecondaryAction>
                  <IconButton onClick={(e) => handleOpen(e, option.message.id)}>
                    <MoreVert />
                  </IconButton>
                </ListItemSecondaryAction>
              </List>
            </React.Fragment>
          ))}
        {!smallScreen && (
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>{intl.formatMessage(form.title)}</TableCell>
                  <TableCell>{intl.formatMessage(common.campaign)}</TableCell>
                  <TableCell>
                    {intl.formatMessage(common.expirationDate)}
                  </TableCell>
                  <TableCell>{intl.formatMessage(form.push)}</TableCell>
                  <TableCell>{intl.formatMessage(form.banner)}</TableCell>
                  <TableCell>Distr auto</TableCell>
                  <TableCell>Immagine</TableCell>
                  <TableCell>Thumb</TableCell>

                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              {messagesCampaigns.sort(byDate).map((option) => (
                <TableBody key={option.message.id}>
                  <TableRow>
                    <TableCell>{option.message.title}</TableCell>
                    <TableCell>
                      {campaigns.find(
                        (x) => x.campaign_id == option.message.campaign_id
                      )
                        ? campaigns.find(
                            (x) => x.campaign_id == option.message.campaign_id
                          ).name
                        : intl.formatMessage(campaign.noCampaign)}
                    </TableCell>
                    <TableCell>
                      {getExpDate(option.message.expire_at)}
                    </TableCell>
                    <TableChecks
                      items={[
                        option.mobile_config.push_notification,
                        option.mobile_config.banner,
                        !!option.message.auto_distr,
                      ]}
                    ></TableChecks>
                    <TableCell>
                      <Thumb url={option.message.image_url} title="Image" />
                    </TableCell>
                    <TableCell>
                      <Thumb url={option.message.thumb_url} title="Thumb" />
                    </TableCell>
                    <TableCell>
                      <IconButton
                        onClick={(e) => handleOpen(e, option.message.id)}
                        style={{ padding: 0 }}
                      >
                        <MoreVert />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                </TableBody>
              ))}
            </Table>
          </TableContainer>
        )}
      </Card>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => {
          setAnchorEl(null);
          setMessage(null);
        }}
      >
        <MenuItem onClick={handleEdit}>
          <ListItemIcon>
            <Create fontSize="small" />
          </ListItemIcon>
          <Typography variant="inherit">
            {intl.formatMessage(common.modify)}
          </Typography>
        </MenuItem>
        <MenuItem onClick={handleDuplicate}>
          <ListItemIcon>
            <FileCopy fontSize="small" />
          </ListItemIcon>
          <Typography variant="inherit">
            {" "}
            {intl.formatMessage(common.clone)}
          </Typography>
        </MenuItem>
        <MenuItem onClick={() => setShowDeleteAlert(true)}>
          <ListItemIcon>
            <Delete fontSize="small" />
          </ListItemIcon>
          <Typography variant="inherit">
            {intl.formatMessage(common.delete)}
          </Typography>
        </MenuItem>
      </Menu>

      <Confirm
        open={showDeleteAlert}
        onConfirm={handleConfirm}
        onCancel={() => {
          setMessage(null);
          setShowDeleteAlert(false);
        }}
        text={intl.formatMessage(confirm.deleteElement)}
      />
      <Dialog open={imgDialog.open} onClose={closeImg} maxWidth="sm" fullWidth>
        <DialogTitle>{imgDialog.title}</DialogTitle>
        <DialogContent>
          <ImagePreview
            url={imgDialog.url}
            alt={imgDialog.title}
            variant="dialog"
            maxHeight="70vh"
            maxWidth="100%"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={closeImg} color="primary">
            {intl.formatMessage(common.close)}
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}
